import { FC } from 'react'
import {
  StyleCard,
  StyleCardFooter,
  StyleCardHeader,
  StyleLeftCardHeader,
  StyleRightCardHeader,
  StyleTag,
} from './style'
import Image from '@components/image'
import Column from '@components/column'
import Row from '@components/row'
import Typography from '@components/typography'
import Button from '@components/button'
import Status from '@commons/status'
import ScheduleCard from '../schedule'
import Svg from '@components/svg'
interface AppointmentRequestCardProps {
  styleCard?: string
  appointment?: any
}
const AppointmentRequestCard: FC<AppointmentRequestCardProps> = ({
  styleCard,
  appointment,
}) => {
  return (
    <StyleCard styleCard={styleCard}>
      <Column data-cross-type={`view-${appointment?.id}`}>
        <StyleCardHeader>
          <StyleLeftCardHeader>
            <Image
              src={`${process.env.BUCKET_URL}/${appointment?.patient?.avatar}`}
              styleImage="border-radius:50%;"
              width={50}
              height={50}
              fallbackType="user"
            />
            <Column rowGap={10}>
              <Typography
                content={appointment?.patient?.name}
                size={14}
                tc="text"
              />
              <Row colGap={10}>
                <StyleTag>{appointment?.patient?.infos?.gender}</StyleTag>
                <StyleTag>{appointment?.patient?.infos?.age}</StyleTag>
                <StyleTag>{appointment?.patient?.infos?.bloodGroup}</StyleTag>
              </Row>
            </Column>
          </StyleLeftCardHeader>
          <StyleRightCardHeader>
            <Status status={appointment?.status} />
          </StyleRightCardHeader>
        </StyleCardHeader>
        <Row
          justifyContent="space-between"
          colGap={10}
          styleRow="margin-top:20px;"
        >
          <ScheduleCard date={appointment?.date} />
          <Button
            leftComponent={<Svg svg="message" color={'primary'} />}
            title=""
            height={40}
            outline
            styleButton="font-size:12px;"
            data-cross-type={`message-${appointment?.id}`}
            data-receiver={`${appointment?.patient?.id}-${appointment?.patient?.name}-${appointment?.patient?.avatar}`}
          />
        </Row>
      </Column>
      <StyleCardFooter>
        {appointment?.status == 'Pending' ? (
          <>
            <Button
              title="Reschedule"
              outline
              radius={8}
              height={40}
              styleButtonWrapper="width:48%"
              styleButton="width:100%;"
              data-cross-type={`reschedule-${appointment?.id}`}
            />
            <Button
              title="Confirm"
              radius={8}
              height={40}
              styleButtonWrapper="width:48%"
              styleButton="width:100%;"
              data-cross-type={`confirm-${appointment?.id}`}
            />
          </>
        ) : (
          <>
            {appointment?.status == 'Confirmed' && (
              <>
                <Button
                  title="Cancel"
                  radius={8}
                  height={40}
                  styleButtonWrapper="width:48%"
                  styleButton="width:100%;"
                  data-cross-type={`cancel-${appointment?.id}`}
                  outline
                  bg="danger"
                />
                <Button
                  title="Reschedule"
                  radius={8}
                  height={40}
                  styleButtonWrapper="width:48%"
                  styleButton="width:100%;"
                  data-cross-type={`reschedule-${appointment?.id}`}
                />
              </>
            )}
            {appointment?.status == 'On Going' && (
              <>
                <Button
                  title="View Details"
                  outline
                  radius={8}
                  height={40}
                  styleButtonWrapper="width:48%"
                  styleButton="width:100%;"
                  data-cross-type={`view-${appointment?.id}`}
                />
                <Button
                  title="Mark as Completed"
                  height={40}
                  radius={8}
                  styleButtonWrapper="width:48%"
                  styleButton="width:100%;"
                  data-cross-type={`complete-${appointment?.id}`}
                />
              </>
            )}
            {(appointment?.status == 'Completed' ||
              appointment?.status == 'Cancelled') && (
              <>
                <Button
                  title="View Details"
                  radius={8}
                  height={40}
                  styleButtonWrapper="width:100%"
                  styleButton="width:100%;"
                  data-cross-type={`view-${appointment?.id}`}
                />
              </>
            )}
          </>
        )}
      </StyleCardFooter>
    </StyleCard>
  )
}

export default AppointmentRequestCard
